import { useQuery } from '@tanstack/react-query'
import { useAPI } from '../../Contexts/APIContext'

const MAX_PAGES = 50
const PAGE_LIMIT = 50

export default function useAllCollections({ enabled = true } = {}) {
  const { getCollections } = useAPI()

  return useQuery({
    queryKey: ['allCollections'],
    queryFn: async () => {
      const allCollections = []
      let expectedPageSize = null

      for (let page = 1; page <= MAX_PAGES; page++) {
        const res = await getCollections(page, PAGE_LIMIT)
        if (!res?.lists?.length) break

        if (expectedPageSize === null) {
          expectedPageSize = res.lists.length
        }

        allCollections.push(...res.lists.map(item => ({
          ...item,
          name: item.list?.name || item.name,
          f_id: item.list?.f_id || item.f_id,
          is_public: item.list?.is_public ?? item.is_public,
        })))

        if (res.lists.length < expectedPageSize) break
      }

      return allCollections
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    enabled,
  })
}
